import { useState, useCallback } from "react";

import { className } from "../../../Utils";

import Accordion from './accordion/Accordion';
import AppCarousel from '../../carousel/AppsCarousel'

import { useTranslations } from "../../../lang/TranslationHooks";

//import free_functionality from '../../Pregnancy/assets/free.mp4'
import pregnancyModule from '../../../assets/modulePregnancy-fixed.mp4'
import moduleParents from '../../../assets/moduleParents-fixed.mp4'
import modulePregnancyPLus from '../../../assets/modulePregnancyPLUS_1.mp4'
import modulePregnancyMINIAPPS from '../../../assets/modulePregnancyMINIAPPS-fixed.mp4'
import ParentsPLUSbg from '../../../assets/ParentsPLUSbg-fixed.mp4'
import ParentsMINIAPPSbg from '../../../assets/ParentsMINIAPPSbg-fixed.mp4'
import cloudsWwhite from '../assets/clouds-white.png'
// import feiaPlus from '../../Pregnancy/assets/feiaplus.mp4'
// import miniAps from '../../Pregnancy/assets/miniapps.mp4'


import './AccordionsSection.css'
import { useSelector } from "react-redux";

const AccordionSection = ({ sections }) => {
    let { staticTranslate } = useTranslations();
    const { language } = useSelector((state) => state.home)
    const [openAccordionIndex, setOpenAccordionIndex] = useState(null);

    const accordionData = [
        {
            title: staticTranslate('t_pregnancy_accordion_functioanality_title', true),
            videoUrl: pregnancyModule,
            freeFunctionality: true,
            data: [
                { id: 1, title: staticTranslate('t_pregnancy_accordion_functioanality_data_1_title', true), content: staticTranslate('t_pregnancy_accordion_functioanality_data_1_content', true) },
                { id: 2, title: staticTranslate('t_pregnancy_accordion_functioanality_data_2_title', true), content: staticTranslate('t_pregnancy_accordion_functioanality_data_2_content', true) },
                { id: 3, title: staticTranslate('t_pregnancy_accordion_functioanality_data_4_title', true), content: staticTranslate('t_pregnancy_accordion_functioanality_data_4_content', true) },
                { id: 4, title: staticTranslate('t_pregnancy_accordion_functioanality_data_7_title', true), content: staticTranslate('t_pregnancy_accordion_functioanality_data_7_content', true) },
                language === 'bg' && { id: 5, title: staticTranslate('t_pregnancy_accordion_functioanality_data_8_title', true), content: staticTranslate('t_pregnancy_accordion_functioanality_data_8_content', true) },
                { id: 6, title: staticTranslate('t_pregnancy_accordion_functioanality_tasks_title', true), content: staticTranslate('t_pregnancy_accordion_functioanality_tasks_content', true) },
                { id: 7, title: staticTranslate('t_pregnancy_accordion_functioanality_data_3_title', true), content: staticTranslate('t_pregnancy_accordion_functioanality_data_3_content', true) },
                { id: 8, title: staticTranslate('t_pregnancy_accordion_functioanality_data_5_title', true), content: staticTranslate('t_pregnancy_accordion_functioanality_data_5_content', true) },
                { id: 9, title: staticTranslate('t_pregnancy_accordion_functioanality_data_6_title', true), content: staticTranslate('t_pregnancy_accordion_functioanality_data_6_content', true) },
            ].filter(Boolean)
        },
        {
            title: staticTranslate('t_pregnancy_accordion_module_parents_title', true),
            videoUrl: moduleParents,
            freeFunctionality: true,
            data: [
                { id: 1, title: staticTranslate('t_pregnancy_feeding', true), content: staticTranslate('t_pregnancy_feeding_desc', true) },
                { id: 2, title: staticTranslate('t_pregnancy_sleep', true), content: staticTranslate('t_pregnancy_sleep_desc', true) },
                { id: 3, title: staticTranslate('t_pregnancy_child_development', true), content: staticTranslate('t_pregnancy_child_development_desc', true) },
                { id: 4, title: staticTranslate('t_pregnancy_for_mother', true), content: staticTranslate('t_pregnancy_for_mother_desc', true) },
                { id: 5, title: staticTranslate('t_pregnancy_symptoms', true), content: staticTranslate('t_pregnancy_symptoms_desc', true) },
            ]
        },
        {
            title: staticTranslate('t_pregnancy_accordion_module_pregnancy_plus', true),
            videoUrl: modulePregnancyPLus,
            data: [
                { id: 1, title: staticTranslate('t_pregnancy_accordion_important_data_1_title', true), content: staticTranslate('t_pregnancy_accordion_important_data_1_content', true) },
                { id: 2, title: staticTranslate('t_pregnancy_accordion_important_data_2_title', true), content: staticTranslate('t_pregnancy_accordion_important_data_2_content', true) },
                { id: 3, title: staticTranslate('t_pregnancy_accordion_important_data_3_title', true), content: staticTranslate('t_pregnancy_accordion_important_data_3_content', true) },
                { id: 4, title: staticTranslate('t_pregnancy_accordion_important_data_4_title', true), content: staticTranslate('t_pregnancy_accordion_important_data_4_content', true) },
                { id: 5, title: staticTranslate('t_pregnancy_accordion_important_data_5_title', true), content: staticTranslate('t_pregnancy_accordion_important_data_5_content', true) },
                { id: 6, title: staticTranslate('t_pregnancy_accordion_important_data_6_title', true), content: staticTranslate('t_pregnancy_accordion_important_data_6_content', true) },
                { id: 7, title: staticTranslate('t_pregnancy_accordion_important_data_7_title', true), content: staticTranslate('t_pregnancy_accordion_important_data_7_content', true) },
                language === 'bg' && { id: 8, title: staticTranslate('t_pregnancy_accordion_important_data_8_title', true), content: staticTranslate('t_pregnancy_accordion_important_data_8_content', true) },
                { id: 9, title: staticTranslate('t_pregnancy_slider_archive', true), content: staticTranslate('t_pregnancy_slider_archive_content', true) },
                { id: 10, title: staticTranslate('t_pregnancy_accordion_information_title', true), content: staticTranslate('t_pregnancy_accordion_information_content', true) },
            ]
        },
        {
            title: staticTranslate('t_module_parents_plus', true),
            videoUrl: ParentsPLUSbg,
            data: [
                { id: 1, title: staticTranslate('t_examinations_and_imunisations', true), content: staticTranslate('t_examinations_and_imunisations_desc', true) },
                { id: 2, title: staticTranslate('t_pregnancy_accordion_important_data_4_title', true), content: staticTranslate('t_parent_symptoms_desc', true) },
                { id: 3, title: staticTranslate('t_pregnancy_accordion_important_data_5_title', true), content: staticTranslate('t_pregnancy_accordion_important_data_5_content', true) },
                { id: 4, title: staticTranslate('t_pregnancy_accordion_important_data_1_title', true), content: staticTranslate('t_pregnancy_accordion_important_data_1_content', true) },
                { id: 5, title: staticTranslate('t_first_aid', true), content: staticTranslate('t_first_aid_desc', true) },
                { id: 6, title: staticTranslate('t_pediatric_conditions', true), content: staticTranslate('t_first_aid_desc', true) },
                { id: 7, title: staticTranslate('t_first_aid_kit', true), content: staticTranslate('t_first_aid_kit_desc', true) },
                { id: 8, title: staticTranslate('t_pregnancy_accordion_important_data_8_title', true), content: staticTranslate('t_recipes_parents_info', true) },
                { id: 9, title: staticTranslate('t_safe_home', true), content: staticTranslate('t_safe_home_desc', true) }
            ]
        },
        {
            title: staticTranslate('t_pregnancy_module_mini_apps', true),
            videoUrl: modulePregnancyMINIAPPS,
            data: [
                { id: 1, title: staticTranslate('t_pregnancy_accordion_miniaps_data_1_title', true), content: staticTranslate('t_pregnancy_accordion_miniaps_data_1_content', true) },
                { id: 2, title: staticTranslate('t_pregnancy_accordion_miniaps_data_2_title', true), content: staticTranslate('t_pregnancy_accordion_miniaps_data_2_content', true) },
                { id: 3, title: staticTranslate('t_pregnancy_accordion_miniaps_data_3_title', true), content: staticTranslate('t_pregnancy_accordion_miniaps_data_3_content', true) },
                { id: 4, title: staticTranslate('t_pregnancy_accordion_miniaps_data_4_title', true), content: staticTranslate('t_pregnancy_accordion_miniaps_data_4_content', true) },
                { id: 5, title: staticTranslate('t_pregnancy_accordion_miniaps_data_5_title', true), content: staticTranslate('t_pregnancy_accordion_miniaps_data_5_content', true) },
                { id: 6, title: staticTranslate('t_pregnancy_accordion_miniaps_data_6_title', true), content: staticTranslate('t_pregnancy_accordion_miniaps_data_6_content', true) },
                { id: 7, title: staticTranslate('t_pregnancy_accordion_miniaps_data_7_title', true), content: staticTranslate('t_pregnancy_accordion_miniaps_data_7_content', true) },
                { id: 8, title: staticTranslate('t_pregnancy_accordion_miniaps_data_8_title', true), content: staticTranslate('t_pregnancy_accordion_miniaps_data_8_content', true) },
                { id: 9, title: staticTranslate('t_pregnancy_accordion_miniaps_data_9_title', true), content: staticTranslate('t_pregnancy_accordion_miniaps_data_9_content', true) },
                { id: 10, title: staticTranslate('t_pregnancy_accordion_miniaps_chinese_calendar_title', true), content: staticTranslate('t_pregnancy_accordion_miniaps_chinese_calendar_content', true) },
                { id: 12, title: staticTranslate('t_pregnancy_accordion_miniaps_data_10_title', true), content: staticTranslate('t_pregnancy_accordion_miniaps_data_10_content', true) },
                { id: 12, title: staticTranslate('t_pregnancy_accordion_miniaps_data_11_title', true), content: staticTranslate('t_pregnancy_accordion_miniaps_data_11_content', true) }
            ].filter(Boolean)
        },
        {
            title: staticTranslate('t_pregnancy_module_parents_mini_apps', true),
            videoUrl: ParentsMINIAPPSbg,
            data: [
                { id: 1, title: staticTranslate('t_pregnancy_accordion_miniaps_data_2_title', true), content: staticTranslate('t_pregnancy_accordion_miniaps_data_2_content', true) },
                { id: 2, title: staticTranslate('t_pregnancy_accordion_miniaps_data_7_title', true), content: staticTranslate('t_pregnancy_accordion_miniaps_data_7_content', true) },
                { id: 3, title: staticTranslate('t_baby_photo', true), content: staticTranslate('t_baby_photo_desc', true) },
                { id: 4, title: staticTranslate('t_pregnancy_accordion_miniaps_data_3_title', true), content: staticTranslate('t_pregnancy_accordion_miniaps_data_3_content', true) },
                { id: 5, title: staticTranslate('t_pregnancy_accordion_miniaps_data_4_title', true), content: staticTranslate('t_pregnancy_accordion_miniaps_data_4_content', true) },
                { id: 6, title: staticTranslate('t_pregnancy_accordion_miniaps_data_10_title', true), content: staticTranslate('t_your_weight_parents_desc', true) },
                { id: 7, title: staticTranslate('t_goodnight_music', true), content: staticTranslate('t_goodnight_music_desc', true) },
                { id: 8, title: staticTranslate('t_baby_noise', true), content: staticTranslate('t_baby_noise_desc', true) },
                { id: 9, title: staticTranslate('t_pregnancy_accordtion_miniapps_magic_meter_title', true), content: staticTranslate('t_pregnancy_accordtion_miniapps_magic_meter_content', true) },
                { id: 10, title: staticTranslate('t_pregnancy_accordtion_miniapps_massage_title', true), content: staticTranslate('t_pregnancy_accordtion_miniapps_massage_content', true) },
                { id: 11, title: staticTranslate('t_pregnancy_accordtion_miniapps_mom_sings_title', true), content: staticTranslate('t_pregnancy_accordtion_miniapps_mom_sings_content', true) },

            ]
        },
        {
            title: staticTranslate('t_pregnancy_module_tracker', true),
            data: [
                { id: 1, title: staticTranslate('t_diaper_tracker', true), content: staticTranslate('t_diaper_tracker_desc', true) },
                { id: 2, title: staticTranslate('t_feeding_tracker', true), content: staticTranslate('t_feeding_tracker_desc', true) },
                { id: 3, title: staticTranslate('t_breastfeeding', true), content: staticTranslate('t_breastfeeding_tracker_desc', true) },
                { id: 4, title: staticTranslate('t_growth_tracker', true), content: staticTranslate('t_growth_tracker_desc', true) },
                { id: 5, title: staticTranslate('t_sleep_diary', true), content: staticTranslate('t_sleep_tracker_desc', true) },
                { id: 6, title: staticTranslate('t_feeding_title', true), content: staticTranslate('t_feeding_content', true) },

            ]
        },
        {
            title: staticTranslate('t_pregnancy_slider_parents', true),
            data: []
        },

        // {
        //     title: staticTranslate('t_pregnancy_accordion_important_title', true),
        //     videoUrl: feiaPlus,
        //     data: [
        //         { id: 1, title: staticTranslate('t_pregnancy_accordion_important_data_1_title', true), content: staticTranslate('t_pregnancy_accordion_important_data_1_content', true) },
        //         { id: 2, title: staticTranslate('t_pregnancy_accordion_important_data_2_title', true), content: staticTranslate('t_pregnancy_accordion_important_data_2_content', true) },
        //         { id: 3, title: staticTranslate('t_pregnancy_accordion_important_data_3_title', true), content: staticTranslate('t_pregnancy_accordion_important_data_3_content', true) },
        //         { id: 4, title: staticTranslate('t_pregnancy_accordion_important_data_4_title', true), content: staticTranslate('t_pregnancy_accordion_important_data_4_content', true) },
        //         { id: 5, title: staticTranslate('t_pregnancy_accordion_important_data_5_title', true), content: staticTranslate('t_pregnancy_accordion_important_data_5_content', true) },
        //         { id: 6, title: staticTranslate('t_pregnancy_accordion_important_data_6_title', true), content: staticTranslate('t_pregnancy_accordion_important_data_6_content', true) },
        //         { id: 7, title: staticTranslate('t_pregnancy_accordion_important_data_7_title', true), content: staticTranslate('t_pregnancy_accordion_important_data_7_content', true) },
        //         language === 'bg' && { id: 8, title: staticTranslate('t_pregnancy_accordion_important_data_8_title', true), content: staticTranslate('t_pregnancy_accordion_important_data_8_content', true) }
        //     ].filter(Boolean)
        // },
        // {
        //     title: staticTranslate('t_pregnancy_accordion_miniaps_title', true),
        //     videoUrl: miniAps,
        //     data: [
        //         { id: 1, title: staticTranslate('t_pregnancy_accordion_miniaps_data_1_title', true), content: staticTranslate('t_pregnancy_accordion_miniaps_data_1_content', true) },
        //         { id: 2, title: staticTranslate('t_pregnancy_accordion_miniaps_data_2_title', true), content: staticTranslate('t_pregnancy_accordion_miniaps_data_2_content', true) },
        //         { id: 3, title: staticTranslate('t_pregnancy_accordion_miniaps_data_3_title', true), content: staticTranslate('t_pregnancy_accordion_miniaps_data_3_content', true) },
        //         { id: 4, title: staticTranslate('t_pregnancy_accordion_miniaps_data_4_title', true), content: staticTranslate('t_pregnancy_accordion_miniaps_data_4_content', true) },
        //         { id: 5, title: staticTranslate('t_pregnancy_accordion_miniaps_data_5_title', true), content: staticTranslate('t_pregnancy_accordion_miniaps_data_5_content', true) },
        //         { id: 6, title: staticTranslate('t_pregnancy_accordion_miniaps_data_6_title', true), content: staticTranslate('t_pregnancy_accordion_miniaps_data_6_content', true) },
        //         { id: 7, title: staticTranslate('t_pregnancy_accordion_miniaps_data_7_title', true), content: staticTranslate('t_pregnancy_accordion_miniaps_data_7_content', true) },
        //         { id: 8, title: staticTranslate('t_pregnancy_accordion_miniaps_data_8_title', true), content: staticTranslate('t_pregnancy_accordion_miniaps_data_8_content', true) },
        //         { id: 9, title: staticTranslate('t_pregnancy_accordion_miniaps_data_9_title', true), content: staticTranslate('t_pregnancy_accordion_miniaps_data_9_content', true) },
        //         { id: 10, title: staticTranslate('t_pregnancy_accordion_miniaps_data_10_title', true), content: staticTranslate('t_pregnancy_accordion_miniaps_data_10_content', true) },
        //         { id: 11, title: staticTranslate('t_pregnancy_accordion_miniaps_data_11_title', true), content: staticTranslate('t_pregnancy_accordion_miniaps_data_11_content', true) }
        //     ].filter(Boolean)
        // }
    ];

    const internationalData = [
        {
            title: staticTranslate('t_pregnancy_accordion_functioanality_title', true),
            // videoUrl: free_functionality,
            freeFunctionality: true,
            data: [
                {
                    id: 1,
                    title: staticTranslate('t_pregnancy_accordion_functioanality_data_1_title', true),
                    content: staticTranslate('t_pregnancy_accordion_functioanality_data_1_content', true),
                    contentMobile: staticTranslate('t_pregnancy_accordion_functioanality_data_1_content', true),
                },
                {
                    id: 2,
                    title: staticTranslate('t_pregnancy_accordion_functioanality_data_2_title', true),
                    content: staticTranslate('t_pregnancy_accordion_functioanality_data_2_content', true),
                    contentMobile: staticTranslate('t_pregnancy_accordion_functioanality_data_2_content', true),
                },
                {
                    id: 3,
                    title: staticTranslate('t_pregnancy_accordion_functioanality_data_3_title', true),
                    content: staticTranslate('t_pregnancy_accordion_functioanality_data_3_content', true),
                    contentMobile: staticTranslate('t_pregnancy_accordion_functioanality_data_3_content', true),
                },
                {
                    id: 4,
                    title: staticTranslate('t_pregnancy_accordion_functioanality_data_4_title', true),
                    content: staticTranslate('t_pregnancy_accordion_functioanality_data_4_content'),
                    contentMobile: staticTranslate('t_pregnancy_accordion_functioanality_data_4_contentmobile'),
                },
                {
                    id: 5,
                    title: staticTranslate('t_pregnancy_accordion_functioanality_data_5_title', true),
                    content: staticTranslate('t_pregnancy_accordion_functioanality_data_5_content', true),
                    contentMobile: staticTranslate('t_pregnancy_accordion_functioanality_data_5_content', true),
                },
                {
                    id: 6,
                    title: staticTranslate('t_pregnancy_accordion_functioanality_data_6_title', true),
                    content: staticTranslate('t_pregnancy_accordion_functioanality_data_6_content', true),
                    contentMobile: staticTranslate('t_pregnancy_accordion_functioanality_data_6_content', true),

                },
                {
                    id: 7,
                    title: staticTranslate('t_pregnancy_accordion_functioanality_data_7_title', true),
                    content: staticTranslate('t_pregnancy_accordion_functioanality_data_7_content', true),
                    contentMobile: staticTranslate('t_pregnancy_accordion_functioanality_data_7_content', true),
                }, {
                    id: 8,
                    title: staticTranslate('t_pregnancy_accordion_functioanality_data_8_title', true),
                    content: staticTranslate('t_pregnancy_accordion_functioanality_data_8_content'),
                    contentMobile: staticTranslate('t_pregnancy_accordion_functioanality_data_8_content'),
                },
                {
                    id: 9,
                    title: staticTranslate('t_pregnancy_accordion_functioanality_data_9_title', true),
                    content: staticTranslate('t_pregnancy_accordion_functioanality_data_9_content', true),
                    contentMobile: staticTranslate('t_pregnancy_accordion_functioanality_data_9_content', true),
                }
            ]
        },
        {
            title: staticTranslate('t_pregnancy_accordion_important_title', true),
            // videoUrl: feiaPlus,
            data: [
                {
                    id: 1,
                    title: staticTranslate('t_pregnancy_accordion_important_data_1_title', true),
                    content: staticTranslate('t_pregnancy_accordion_important_data_1_content'),
                    contentMobile: staticTranslate('t_pregnancy_accordion_important_data_1_contentmobile', true),
                },
                {
                    id: 4,
                    title: staticTranslate('t_pregnancy_accordion_important_data_4_title', true),
                    content: staticTranslate('t_pregnancy_accordion_important_data_4_content', true),
                    contentMobile: staticTranslate('t_pregnancy_accordion_important_data_4_content', true)
                },
                {
                    id: 5,
                    title: staticTranslate('t_pregnancy_accordion_important_data_5_title', true),
                    content: staticTranslate('t_pregnancy_accordion_important_data_5_content', true),
                    contentMobile: staticTranslate('t_pregnancy_accordion_important_data_5_content', true),
                },
                {
                    id: 6,
                    title: staticTranslate('t_pregnancy_accordion_important_data_6_title', true),
                    content: staticTranslate('t_pregnancy_accordion_important_data_6_content', true),
                    contentMobile: staticTranslate('t_pregnancy_accordion_important_data_6_content', true),
                },
                {
                    id: 7,
                    title: staticTranslate('t_pregnancy_accordion_important_data_7_title', true),
                    content: staticTranslate('t_pregnancy_accordion_important_data_7_content', true),
                    contentMobile: staticTranslate('t_pregnancy_accordion_important_data_7_content', true),
                },
                {
                    id: 10,
                    title: staticTranslate('t_pregnancy_accordion_important_data_10_title', true),
                    content: staticTranslate('t_pregnancy_accordion_important_data_10_content', true),
                    contentMobile: staticTranslate('t_pregnancy_accordion_important_data_10_content', true)
                }

            ]



        },
        {
            title: staticTranslate('t_pregnancy_accordion_miniaps_title', true),
            // videoUrl: miniAps,
            data: [
                {
                    id: 1,
                    title: staticTranslate('t_pregnancy_accordion_miniaps_data_1_title', true),
                    content: staticTranslate('t_pregnancy_accordion_miniaps_data_1_content', true),
                    contentMobile: staticTranslate('t_pregnancy_accordion_miniaps_data_1_content', true)
                },
                {
                    id: 2,
                    title: staticTranslate('t_pregnancy_accordion_miniaps_data_2_title', true),
                    content: staticTranslate('t_pregnancy_accordion_miniaps_data_2_content'),
                    contentMobile: staticTranslate('t_pregnancy_accordion_miniaps_data_2_contentmobile', true)

                },
                {
                    id: 3,
                    title: staticTranslate('t_pregnancy_accordion_miniaps_data_3_title', true),
                    content: staticTranslate('t_pregnancy_accordion_miniaps_data_3_content'),
                    contentMobile: staticTranslate('t_pregnancy_accordion_miniaps_data_3_contentmobile', true)
                },
                {
                    id: 4,
                    title: staticTranslate('t_pregnancy_accordion_miniaps_data_4_title', true),
                    content: staticTranslate('t_pregnancy_accordion_miniaps_data_4_content'),
                    contentMobile: staticTranslate('t_pregnancy_accordion_miniaps_data_4_contentmobile', true)

                },
                {
                    id: 5,
                    title: staticTranslate('t_pregnancy_accordion_miniaps_data_5_title', true),
                    content: staticTranslate('t_pregnancy_accordion_miniaps_data_5_content'),
                    contentMobile: staticTranslate('t_pregnancy_accordion_miniaps_data_5_contentmobile', true)
                },
                {
                    id: 6,
                    title: staticTranslate('t_pregnancy_accordion_miniaps_data_6_title', true),
                    content: staticTranslate('t_pregnancy_accordion_miniaps_data_6_content', true),
                    contentMobile: staticTranslate('t_pregnancy_accordion_miniaps_data_6_content', true)
                },
                {
                    id: 7,
                    title: staticTranslate('t_pregnancy_accordion_miniaps_data_7_title', true),
                    content: staticTranslate('t_pregnancy_accordion_miniaps_data_7_content', true),
                    contentMobile: staticTranslate('t_pregnancy_accordion_miniaps_data_7_content', true)
                },
                {
                    id: 8,
                    title: staticTranslate('t_pregnancy_accordion_miniaps_data_8_title', true),
                    content: staticTranslate('t_pregnancy_accordion_miniaps_data_8_content', true),
                    contentMobile: staticTranslate('t_pregnancy_accordion_miniaps_data_8_contentmobile', true)
                },
                {
                    id: 9,
                    title: staticTranslate('t_pregnancy_accordion_miniaps_data_9_title', true),
                    content: staticTranslate('t_pregnancy_accordion_miniaps_data_9_content', true),
                    contentMobile: staticTranslate('t_pregnancy_accordion_miniaps_data_9_contentmobile', true)
                },
                {
                    id: 10,
                    title: staticTranslate('t_pregnancy_accordion_miniaps_data_10_title', true),
                    content: staticTranslate('t_pregnancy_accordion_miniaps_data_10_content', true),
                    contentMobile: staticTranslate('t_pregnancy_accordion_miniaps_data_10_contentmobile', true)
                },
                {
                    id: 11,
                    title: staticTranslate('t_pregnancy_accordion_miniaps_data_11_title', true),
                    content: staticTranslate('t_pregnancy_accordion_miniaps_data_11_content', true),
                    contentMobile: staticTranslate('t_pregnancy_accordion_miniaps_data_11_contentmobile', true)
                },
                { id: 12, title: staticTranslate('t_pregnancy_accordion_miniaps_chinese_calendar_title', true), content: staticTranslate('t_pregnancy_accordion_miniaps_chinese_calendar_content', true) },

            ]

        }
    ];

    const currnetData = language === 'bg' ? accordionData : internationalData

    const handleSetOpenAccordion = useCallback((index) => {
        setOpenAccordionIndex((prevIndex) => (prevIndex === index ? null : index));
    }, []);
    return (

        <div id={sections} className={className('accordion-section-container')}>
            {language === 'bg' &&
                <div className={className('clouds-image-wrapper')}>
                    <img
                        src={cloudsWwhite}
                        alt="cloudsWwhite"

                    />
                </div>
            }
            <h2 className={className('accordions-title')}>
                {staticTranslate('t_pregnancy_accordion_title', true)}
            </h2>
            <h3 className={className('accordions-content')}>
                {staticTranslate('t_pregnancy_accordion_subtitle', true)}
            </h3>
            <AppCarousel />

            <section className={className('plans-container')}>
                <p>{staticTranslate('t_home_feia', true)} <span>{staticTranslate('t_free_plan', true)}</span></p>
                <p><span>{staticTranslate('t_feia_premium', true)}</span> {staticTranslate('t_pregnancy_plan', true)}</p>
            </section>

            {currnetData.map((accordion, index) => (
                <Accordion
                    key={index}
                    {...accordion}
                    isOpen={openAccordionIndex === index}
                    setOpenAccordion={() => handleSetOpenAccordion(index)} // ✅ stable function

                />
            ))}

            <p className={className("accordion-section-container-info-text")}>
                {staticTranslate('t_pregnancy_accordion_container_text_info', true)}
            </p>
        </div>

    );
}

export default AccordionSection